export default {
    wechat_user: null,
    trainer: null,
    jssdk: {},
};



// WEBPACK FOOTER //
// ./src/store/wechat/state.js